// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content{
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    flex-grow: 1;
}

.topbar{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:30px;
}

.topbar button{
    cursor:pointer;
    margin-left:12px;
}

.search{
    width:350px;
    padding:14px;
    border:1px solid #cbd5e1;
    border-radius:10px;
    font-size:15px;
}

.search-btn{
    display:flex;
}

/* GRID */

.grid{
    display:grid;
    grid-template-columns:repeat(auto-fill,minmax(min(360px, 100%),1fr));
    gap:25px;
    flex:1;
    overflow-y:auto;
}

/* CARD */

.card{
    cursor:pointer;
    display:none;
    background:white;
    border-radius:18px;
    overflow:hidden;
    box-shadow:0 10px 25px rgba(0,0,0,.08);
    transition:.3s;
}

.card:hover{
    transform:translateY(-6px);
}

.card img{
    max-width:100%;
    height:240px;
    object-fit:cover;
}

.card-mobile{
    background:white;
    overflow:hidden;
    box-shadow:0 10px 25px rgba(0,0,0,.08);
    transition:.3s;
}

.card-mobile img{
    max-width:100%;
    height:240px;
    object-fit:cover;
}

.card-body{
    padding:24px;
}

.price{
    font-size:34px;
    font-weight:700;
    color:#dc2626;
}

.installment{
    font-size:16px;
    font-weight:700;
    color:#dc2626;
}

.title{
    font-size: 24px;
    line-height: 32px;
    min-height: 64px;    
    max-height: 64px;
    font-weight:600;
    margin-top:6px;
    margin-bottom:20px;
}

/* QUICK INFO */

.quick-info{
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:12px;
    margin-bottom:24px;
}

.image-container-mobile{
    position:relative;
    display:flex;
    margin-bottom: 12px;
    overflow: hidden;
}

.image-container-mobile img {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
}

.mobile-price-div {
  position: absolute;
  margin: 10px 10px; 
  bottom: 0%;
  left: 0%;
}

.mobile-price-text {
  margin: 0px;
  color: #FFFFFF;
  text-shadow : 1px 1px black;
  font-size: 1.2em;
}

.mobile-installment-text {
  margin: 0px;
  color: #FFFFFF;
  text-shadow : 1px 1px black;
  font-size: 0.75em;
  font-weight: 700;
}

.info-item{
    background:#f8fafc;
    border:1px solid #e2e8f0;
    padding:14px;
    border-radius:12px;
}

.info-item-mobile{
    background:#f8fafc;
    display:flex;
    border:1px solid #e2e8f0;
    padding:8px;
    justify-content:space-between;
}

.label{
    display:block;
    font-size:11px;
    text-transform:uppercase;
    letter-spacing:1px;
    color:#64748b;
    margin-bottom:5px;
}

.value{
    display:block;
    font-size:15px;
    font-weight:600;
    color:#0f172a;
}

/* CONDITION */

.condition{
    border-top:1px solid #e2e8f0;
    border-bottom:1px solid #e2e8f0;
    padding:18px 0;
    margin-bottom:20px;
}

.condition-title{
    font-size:12px;
    text-transform:uppercase;
    letter-spacing:1px;
    color:#64748b;
}

.condition-status{
    font-size:20px;
    font-weight:700;
    margin-top:8px;
}

.non-accident{
    color:#16a34a;
}

.minor{
    color:#ca8a04;
}

.major{
    color:#dc2626;
}

.report{
    margin-top:8px;
    color:#64748b;
    font-size:14px;
    line-height:1.5;
}

/* BUTTON */

.btn{
    display:block;
    text-align:center;
    text-decoration:none;
    background:#0f172a;
    color:white;
    padding:14px;
    border-radius:10px;
    font-weight:600;
    transition:.3s;
}

.btn:hover{
    background:#1e293b;
}

@media (min-width: 768px) {
    .card{
        display:block;
    }
    .card-mobile{
        display:none;
    }
    .search{
        width:240px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Listing/css/ListingContent.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA,SAAS;;AAET;IACI,YAAY;IACZ,oEAAoE;IACpE,QAAQ;IACR,MAAM;IACN,eAAe;AACnB;;AAEA,SAAS;;AAET;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA,eAAe;;AAEf;IACI,YAAY;IACZ,6BAA6B;IAC7B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA,cAAc;;AAEd;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".content{\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 100vh;\r\n    flex-grow: 1;\r\n}\r\n\r\n.topbar{\r\n    display:flex;\r\n    justify-content:space-between;\r\n    align-items:center;\r\n    margin-bottom:30px;\r\n}\r\n\r\n.topbar button{\r\n    cursor:pointer;\r\n    margin-left:12px;\r\n}\r\n\r\n.search{\r\n    width:350px;\r\n    padding:14px;\r\n    border:1px solid #cbd5e1;\r\n    border-radius:10px;\r\n    font-size:15px;\r\n}\r\n\r\n.search-btn{\r\n    display:flex;\r\n}\r\n\r\n/* GRID */\r\n\r\n.grid{\r\n    display:grid;\r\n    grid-template-columns:repeat(auto-fill,minmax(min(360px, 100%),1fr));\r\n    gap:25px;\r\n    flex:1;\r\n    overflow-y:auto;\r\n}\r\n\r\n/* CARD */\r\n\r\n.card{\r\n    cursor:pointer;\r\n    display:none;\r\n    background:white;\r\n    border-radius:18px;\r\n    overflow:hidden;\r\n    box-shadow:0 10px 25px rgba(0,0,0,.08);\r\n    transition:.3s;\r\n}\r\n\r\n.card:hover{\r\n    transform:translateY(-6px);\r\n}\r\n\r\n.card img{\r\n    max-width:100%;\r\n    height:240px;\r\n    object-fit:cover;\r\n}\r\n\r\n.card-mobile{\r\n    background:white;\r\n    overflow:hidden;\r\n    box-shadow:0 10px 25px rgba(0,0,0,.08);\r\n    transition:.3s;\r\n}\r\n\r\n.card-mobile img{\r\n    max-width:100%;\r\n    height:240px;\r\n    object-fit:cover;\r\n}\r\n\r\n.card-body{\r\n    padding:24px;\r\n}\r\n\r\n.price{\r\n    font-size:34px;\r\n    font-weight:700;\r\n    color:#dc2626;\r\n}\r\n\r\n.installment{\r\n    font-size:16px;\r\n    font-weight:700;\r\n    color:#dc2626;\r\n}\r\n\r\n.title{\r\n    font-size: 24px;\r\n    line-height: 32px;\r\n    min-height: 64px;    \r\n    max-height: 64px;\r\n    font-weight:600;\r\n    margin-top:6px;\r\n    margin-bottom:20px;\r\n}\r\n\r\n/* QUICK INFO */\r\n\r\n.quick-info{\r\n    display:grid;\r\n    grid-template-columns:1fr 1fr;\r\n    gap:12px;\r\n    margin-bottom:24px;\r\n}\r\n\r\n.image-container-mobile{\r\n    position:relative;\r\n    display:flex;\r\n    margin-bottom: 12px;\r\n    overflow: hidden;\r\n}\r\n\r\n.image-container-mobile img {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n}\r\n\r\n.mobile-price-div {\r\n  position: absolute;\r\n  margin: 10px 10px; \r\n  bottom: 0%;\r\n  left: 0%;\r\n}\r\n\r\n.mobile-price-text {\r\n  margin: 0px;\r\n  color: #FFFFFF;\r\n  text-shadow : 1px 1px black;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.mobile-installment-text {\r\n  margin: 0px;\r\n  color: #FFFFFF;\r\n  text-shadow : 1px 1px black;\r\n  font-size: 0.75em;\r\n  font-weight: 700;\r\n}\r\n\r\n.info-item{\r\n    background:#f8fafc;\r\n    border:1px solid #e2e8f0;\r\n    padding:14px;\r\n    border-radius:12px;\r\n}\r\n\r\n.info-item-mobile{\r\n    background:#f8fafc;\r\n    display:flex;\r\n    border:1px solid #e2e8f0;\r\n    padding:8px;\r\n    justify-content:space-between;\r\n}\r\n\r\n.label{\r\n    display:block;\r\n    font-size:11px;\r\n    text-transform:uppercase;\r\n    letter-spacing:1px;\r\n    color:#64748b;\r\n    margin-bottom:5px;\r\n}\r\n\r\n.value{\r\n    display:block;\r\n    font-size:15px;\r\n    font-weight:600;\r\n    color:#0f172a;\r\n}\r\n\r\n/* CONDITION */\r\n\r\n.condition{\r\n    border-top:1px solid #e2e8f0;\r\n    border-bottom:1px solid #e2e8f0;\r\n    padding:18px 0;\r\n    margin-bottom:20px;\r\n}\r\n\r\n.condition-title{\r\n    font-size:12px;\r\n    text-transform:uppercase;\r\n    letter-spacing:1px;\r\n    color:#64748b;\r\n}\r\n\r\n.condition-status{\r\n    font-size:20px;\r\n    font-weight:700;\r\n    margin-top:8px;\r\n}\r\n\r\n.non-accident{\r\n    color:#16a34a;\r\n}\r\n\r\n.minor{\r\n    color:#ca8a04;\r\n}\r\n\r\n.major{\r\n    color:#dc2626;\r\n}\r\n\r\n.report{\r\n    margin-top:8px;\r\n    color:#64748b;\r\n    font-size:14px;\r\n    line-height:1.5;\r\n}\r\n\r\n/* BUTTON */\r\n\r\n.btn{\r\n    display:block;\r\n    text-align:center;\r\n    text-decoration:none;\r\n    background:#0f172a;\r\n    color:white;\r\n    padding:14px;\r\n    border-radius:10px;\r\n    font-weight:600;\r\n    transition:.3s;\r\n}\r\n\r\n.btn:hover{\r\n    background:#1e293b;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .card{\r\n        display:block;\r\n    }\r\n    .card-mobile{\r\n        display:none;\r\n    }\r\n    .search{\r\n        width:240px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
